import { Tag as AntDTag } from 'antd';
import styled from 'styled-components';

export const Badge = styled(AntDTag)`
  padding: 0px 20px;
  font-size: 14px;
  min-width: 0;
  background-color: ${({ color = '#EAEAEA' }) => color};
  border-radius: 0.5rem;
  &:hover {
    background-color: #f4f4f4;
  }
`;
